import { ISection } from '@sdk/contracts';
import { Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddDescriptionButton } from './AddSectionDescription.styles';

import { useMutateSection, useProfile } from '@/store';

type Props = {
  section: ISection;
};

const MAX_LENGTH = 750;
const MODAL_WIDTH = 572;

export const AddSectionDescription: React.FC<Props> = ({ section }) => {
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();
  const { updateSection, isWorking } = useMutateSection();
  const description = Form.useWatch('description', form);
  const {
    roleCheck: { isManager, isTeacher }
  } = useProfile();

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleFinish = (values: { description: string }) => {
    updateSection(
      { ...section, description: values.description },
      {
        onSuccess: () => {
          setIsOpen(false);
          form.resetFields();
        }
      }
    );
  };

  const isDescriptionEmpty = !description || description.trim().length === 0;

  if (!isManager && !isTeacher) return null;
  return (
    <>
      <AddDescriptionButton size="large" type="link" onClick={handleOpen}>
        {t('ADD_DESCRIPTION')}
      </AddDescriptionButton>

      <Modal
        title={t('ADD_DESCRIPTION')}
        open={isOpen}
        onCancel={handleCancel}
        centered
        width={MODAL_WIDTH}
        okText={t('DefaultTranslations:ADD')}
        cancelText={t('DefaultTranslations:CANCEL')}
        okButtonProps={{ disabled: isDescriptionEmpty || isWorking, loading: isWorking }}
        onOk={form.submit}>
        <Form form={form} onFinish={handleFinish}>
          <Form.Item name="description" style={{ marginBottom: 64 }}>
            <Input.TextArea
              rows={3}
              maxLength={MAX_LENGTH}
              showCount
              placeholder={t('DefaultTranslations:WRITE_HERE')}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
